import { SVG, SVGProps } from './svg'

export function IconExitFullscreen(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M9 3.5V8c0 .6-.4 1-1 1H3.5a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5H7V3.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5zM20.5 9H16a1 1 0 01-1-1V3.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5V7h3.5c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM17 20.5V17h3.5c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5H16a1 1 0 00-1 1v4.5c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5zm-8.5.5h-1a.5.5 0 01-.5-.5V17H3.5a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5H8c.6 0 1 .4 1 1v4.5c0 .3-.2.5-.5.5z" />
    </SVG>
  )
}
